import HeaderNotificationItem from 'components/App/Header/HeaderMain/HeaderNotificationItem'
import LineBellIcon from 'LuxKit/Icons/line/LineBellIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import useUserNotifications from 'hooks/Notifications/useUserNotifications'
import { useAppSelector } from 'hooks/reduxHooks'
import { rem } from 'polished'
import { memo } from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'

const EmptyState = styled(Group)`
  padding: ${rem(64)} ${rem(20)};
`

function NarBarNotificationsContent() {
  const [notifications] = useUserNotifications()
  const intl = useIntl()
  const isSubscribed = useAppSelector(state => state.leSubscriptions.settings.appPushSubscribed)

  if (!notifications.length) {
    return <EmptyState direction="vertical" gap={8} horizontalAlign="center">
      <LineBellIcon />
      <Group direction="vertical" horizontalAlign="center">
        <BodyText variant="large" weight="bold">
          {intl.formatMessage({
            id: 'QshI7hbfUgZ4Ms52rZI9',
            defaultMessage: 'No new notifications',
            description: 'Empty state title when there are no notifications in the navigation bar',
          })}
        </BodyText>
        {isSubscribed && <BodyText variant="medium">
          {intl.formatMessage({
            id: 'NzzkezgshadeWofQsZ2H',
            defaultMessage: 'We’ll let you know when updates arrive.',
            description: 'Empty state message when user is subscribed to push notifications',
          })}
        </BodyText>}
      </Group>
    </EmptyState>
  }

  return <>
    {notifications.map(notification => <HeaderNotificationItem
      key={notification.id}
      notification={notification}
    />)}
  </>
}

export default memo(NarBarNotificationsContent)
